<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical :headerTitle="menuTitle" :useBtnList="[
                    'btnRetrieve', //Retrieve
                    'btnExcel'
                ]" @btnRetrieve="btnRetrieve()" @btnExcel="onExporting()">
                                        <template v-slot:body>
                                            <v-layout column overflow-auto>
                                                <v-row dense>
                                                    <v-col cols="12" class="pa-0">
                                                        <i-card-top class="d-md-flex" outlined>
                                                            <template v-slot:body>
                                        <v-layout column>
                                            <v-row no-gutters class="center pa-2 pb-0">                                                
                                                <i-label :label="'Org Ship No :'" />
												<v-col cols="1">
													<v-autocomplete		
                                                    v-model="shipNo"											
													:items="shipNoList"    
                                                    outlined
                                                    dense
                                                    height="32"
													@change="getLotNo()"
													/>
												</v-col>
												<i-label :label="'Org Lot No :'" class="pl-2"/>
												<v-col cols="1">
													<v-autocomplete
													v-model="lotNo"
													:items="lotNoList"
													outlined
													dense
													height="32"													
													/>
												</v-col>
                                            <i-label :label="'Act. Cut. Date : '" class="pl-2"/>
                                            <v-col cols="1" >
                                                <DxDateBox
                                                :value="startDate"
                                                height="30px"
                                                display-format="yyyy-MM-dd"
                                                :acceptCustomValue="false"
                                                @value-changed="e => {reqDtFrom = e.value && getStrFormat(e.value)}"
                                                />
                                            </v-col>
                                            <span class="pa-1 subTitle"> ~ </span>
                                            <v-col cols="1">
                                                <DxDateBox
                                                :value="endDate"
                                                height="30px"
                                                display-format="yyyy-MM-dd"
                                                :acceptCustomValue="false"
                                                @value-changed="e => {reqDtFrom = e.value && getEndFormat(e.value)}"
                                                />
                                            </v-col> 
                                            <i-label :label="'Steel Kind:'" class="pl-2"/>
                                                <v-col cols="1">
                                                    <v-select v-model="division.select" :items="division.items" item-text="name" item-value="cd" return-object single-line
                                                        outlined dense />
                                                </v-col>                                                                            
                                            </v-row>
                                            <v-row no-gutters class="center pa-2 pb-0">                                                
                                                <i-label :label="'Use Ship  No :'" />
												<v-col cols="1">
													<v-autocomplete
													v-model="useShipNo"
													:items="useShipNoList"
													single-line
													outlined
													dense
													height="32"
													@change="getUseLotNoList()"
													/>
												</v-col>
												<i-label :label="'Use Lot No :'" class="pl-2"/>
												<v-col cols="1">
													<v-autocomplete
													v-model="useLotNo"
													:items="useLotNoList"
													outlined
													dense
													height="32"													
													/>
												</v-col>
                                                <i-label :label="'Residue Mark :'" class="pl-2" />
                                                <v-col cols="2">
                                                    <v-text-field 
                                                    v-model="residueMark"
                                                    dense 
                                                    outlined 
                                                    hide-details="auto"
                                                    height="32"
                                                    />
                                                </v-col>
                                            <i-label :label="'Use Y/N:'" class="pl-6"/>
                                            <span class="pa-2 subTitle">   </span>
                                                <v-col cols="1">
                                                    <v-select v-model="useDiv.select" :items="useDiv.items" item-text="name" item-value="cd" return-object single-line
                                                        outlined dense />
                                                </v-col>                                                                            
                                            </v-row>
                                        </v-layout>
                                        </template>
                                    </i-card-top>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="pa-0">
                                    <DxDataGrid id="epmsa330" class="listBox" :ref="epmsa330Ref"
                                        :data-source="gridMainList" :remote-operations="false"
                                        :hover-state-enabled="true" :allow-column-resizing="true"
                                        :allow-column-reordering="true" :row-alternation-enabled="true"
                                        :show-borders="true" :width="grid.width" :show-row-lines="true" key-expr="id"
                                        :focused-row-enabled="true" :column-hiding-enabled="false"
                                        :selection="{ mode: 'none' }" :sorting="{ mode: 'none' }"
                                        :word-wrap-enabled="true"    
                                        @exporting="onExporting"                                    
                                        >
                                        <DxExport :enabled="true" />                                       
                                        <DxColumn data-field="id" caption="No" width="3%" data-type="string" 
                                                  :allow-editing="false" alignment="center"  />                                                                            
                                                                                                                     
                                        <DxColumn caption="Mark No" width="20%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="markNo" caption="Original" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true"   />
                                            <DxColumn data-field="jmarkNo" caption="Remain Angle" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true"  />                                               
                                        </DxColumn>                                                                          

                                        <DxColumn caption="Original Ship" width="40%" data-type="string" :allow-editing="false" alignment="center" :visible="true" >
                                            <DxColumn data-field="shipNo" caption="Ship no" width="7%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                            <DxColumn data-field="lotNo" caption="Lot no" width="5%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                            <DxColumn data-field="cutGrp" caption="Cut Grp" width="5%" data-type="string" :allow-editing="false" alignment="center" :visible="true"/>
                                            <DxColumn data-field="dwgPage" caption="DP" width="3%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                            <DxColumn data-field="orgCutPlan" caption="Cut Plan" width="7%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                            <DxColumn data-field="orgActCut" caption="Cut Actual" width="7%" data-type="string"  :allow-editing="false" alignment="center" :visible="true" />
                                        </DxColumn>   
                                        
                                        <DxColumn caption="Remain Angle Information" width="40%" data-type="string" :allow-editing="false" alignment="center" :visible="true" >
                                            <DxColumn data-field="qualityMatl" caption="Quality" width="5%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />                                            
                                            <DxColumn data-field="width1" caption="Width1" width="5%" data-type="number" :allow-editing="false" alignment="center" :visible="true" format='#,###'/>
                                            <DxColumn data-field="width2" caption="Width2" width="5%" data-type="number" :allow-editing="false" alignment="center" :visible="true" format='#,###'/>
                                            <DxColumn data-field="thk1" caption="Thick1" width="5%" data-type="number" :allow-editing="false" alignment="center" :visible="true"  />
                                            <DxColumn data-field="thk2" caption="Thick2" width="5%" data-type="number" :allow-editing="false" alignment="center" :visible="true" />
                                            <DxColumn data-field="length" caption="Length" width="5%" data-type="number" :allow-editing="false" alignment="center" :visible="true" format='#,###'/>
                                            <DxColumn data-field="wgt" caption="Weight" width="5%" data-type="number" :allow-editing="false" alignment="center" :visible="true" format='#,###'/>
                                        </DxColumn>
                                        
                                        <DxColumn caption="New Ship" width="40%" data-type="string" :allow-editing="false" alignment="center" :visible="true" >
                                            <DxColumn data-field="useShipNo" caption="Ship no" width="7%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                            <DxColumn data-field="useLotNo" caption="Lot no" width="5%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                            <DxColumn data-field="useCutGrp" caption="Cut Grp" width="5%" data-type="string" :allow-editing="false" alignment="center" :visible="true"/>
                                            <DxColumn data-field="useDwgPage" caption="DP" width="3%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                            <DxColumn data-field="rmCutPln" caption="Cut Plan" width="7%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                            <DxColumn data-field="rmCutDte" caption="Cut Actual" width="7%" data-type="string"  :allow-editing="false" alignment="center" :visible="true" />                                                         
                                        </DxColumn>   
                                                                                                                                                       
                                        <DxPaging :enabled="true"  />
                                    </DxDataGrid>
                                </v-col>
                            </v-row>
                        </v-layout>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>       
    </v-container>
</template>

<script>
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { epmsa330Detail, getShipNoList, getLotNoList, getUseShipNoList, getUseLotNoList } from '@/api/view/hip/A/epmsa330.js'
import { getDateFormat } from '@/utils/common.js'
import DxDateBox from 'devextreme-vue/date-box'
import {DxExport } from 'devextreme-vue/data-grid'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { getNumComma } from '@/utils/common.js';
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter
} from 'devextreme-vue/data-grid';

export default {
    name: 'epmsa330',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        'i-card-top': iCardTop,
        DxDateBox ,
        DxExport,
        DxColumn,
        DxHeaderFilter  
    },
    data() {
        return {
            makerCd: this.$store.state.user.makerCd,
            menuTitle: this.$route.meta.title,
            gridMainList: [],
            epmsa330Ref: "epmsa330Ref",
            shipNo: '',
            shipNoList: [], 
            
            lotNo: '',
            lotNoList: [],

            useShipNo: '',
            useShipNoList: [],
            
            useLotNo: '',
            useLotNoList: [],

            startDate: '',
            endDate: '',

            stDte: '',
            edDte: '',              
        
            residueMark : '',

            division: {
                select: { name: 'All', cd: '%' },
                items: [
                    { name: 'All', cd: '%' },
                    { name: 'Plate', cd: 'P' },
                    { name: 'Section', cd: 'S' }                  
                ]
            },

            useDiv: {
                select: { name: 'All', cd: '%' },
                items: [
                    { name: 'All', cd: '%' },
                    { name: 'Used', cd: 'Y' },
                    { name: 'Not Used', cd: 'N' }                  
                ]
            },
        }
    },
    computed: {
        gridMainInstance() {
            return this.GetDataGrid(this.epmsa330Ref)
        },
       
    },
    methods: {       
        formatDate(e){
            return e.substring(0,4) + '-' + e.substring(4,2) + '-' + e.substring(6)

        },
        totalFormat(e) {
            const result = getNumComma(Number(e.value.toFixed(2)), 2)
            return result
        },
        totalFormatN0(e) {
            const result = getNumComma(Number(e.value.toFixed(0)))
            return result
        },
        getStrFormat(date) {
            this.stDte = getDateFormat(date)
            return getDateFormat(date)
        },
        getEndFormat(date) {
            this.edDte = getDateFormat(date)
            return getDateFormat(date)
        },   
               
        async getShipNoList(){
            try {
               
                this.openLoading('searching')           

                await getShipNoList().then(res => {
                this.shipNoList.push('')
                res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                });
                this.shipNo = this.shipNoList[0]           
                })
            } finally {       
                this.endLoading()
            }
        },

        async getUseShipNoList(){
            try {
               
                this.openLoading('searching')           

                await getUseShipNoList().then(res => {
                this.useShipNoList.push('')
                res.list.forEach(e => {                
                    if(e != null){
                        this.useShipNoList.push(e.useShipNo)
                    }                         
                });
                this.useShipNo = this.useShipNoList[0]           
                })
            } finally {       
                this.endLoading()
            }
        },

        async getLotNo(){
			this.lotNoList = []
			let param = {        
				shipNo: this.shipNo				
			}

            console.log(param);

			await getLotNoList(param).then(res => {
				this.lotNoList.push('')
				res.list.forEach(e => {
				this.lotNoList.push(e.lotNo)
				});
				this.lotNo = this.lotNoList[0]
			})
        },

        async getUseLotNoList(){
			this.useLotNoList = []
			let param = {        
				shipNo: this.useShipNo				
			}

            console.log(param);

			await getUseLotNoList(param).then(res => {
				this.useLotNoList.push('')
				res.list.forEach(e => {
				this.useLotNoList.push(e.useLotNo)
				});
				this.useLotNo = this.useLotNoList[0]
			})
        },

        btnRetrieve() {           

            this.doSearchMain()
        },
        async doSearchMain() {

            this.openLoading('searching')
            let params = {                
                shipNo:    this.shipNo,
                lotNo:     this.lotNo,
                useShipNo: this.useShipNo,
                useLotNo:  this.useLotNo,
                steelKind: this.division.select.cd,
                markNo:    this.residueMark,
                useYn:     this.useDiv.select.cd,
                startDay: this.stDte.replace(/-/g, ""),
                endDay:  this.edDte.replace(/-/g, ""),
                makerCd: this.makerCd
            }
            console.log(params);
            await epmsa330Detail(params).then(res => {
                let cnt = 1;    
                res.list.forEach(e => {
                    e.id = cnt++
                });
                this.gridMainList = res.list                               
                
            }).finally(() => {
                console.log( this.gridMainList)
                this.endLoading()
            })
            
           
        }, 
        onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Sheet1');

      exportDataGrid({
            component: this.gridMainInstance,
            worksheet,
            topLeftCell: { row: 4, column: 1 },
        }).then((cellRange) => {

            // header
            const titleRow = worksheet.getRow(2);
            titleRow.height = 30;
            worksheet.mergeCells(2, 1, 2, 22);

            titleRow.getCell(1).value = 'Residue Steel Plate/Section List';
            titleRow.getCell(1).font = { name: 'Segoe UI Light', size: 22, bold: true };
            titleRow.getCell(1).alignment = { horizontal: 'center' , vertical: 'middle' };

             // condition
             const condRow = worksheet.getRow(3);
            condRow.height = 20;
            worksheet.mergeCells(3, 1, 3, 3);
            worksheet.mergeCells(3, 4, 3, 20);
            worksheet.mergeCells(3, 21, 3, 22);
              

            condRow.getCell('A').value = 'REPORT NO : A033';
            condRow.getCell('A').font = { name: 'Calibri', size: 12, bold: true };
            condRow.getCell('A').alignment = { horizontal: 'left' , vertical: 'middle' } ;

            condRow.getCell('D').value = 'FROM DATE : ' + this.stDte + ' ~ ' + this.edDte;
            condRow.getCell('D').font = { name: 'Calibri', size: 12, bold: true };
            condRow.getCell('D').alignment = { horizontal: 'left' , vertical: 'middle' } ;

            const date = new Date();
            const year = date.getFullYear();
            const month = ('0' + (date.getMonth() + 1)).slice(-2); // Months are zero-based
            const day = ('0' + date.getDate()).slice(-2);

            condRow.getCell('U').value = 'Print date : ' + `${year}-${month}-${day}`;
            condRow.getCell('U').font = { name: 'Calibri', size: 12, bold: true };
            condRow.getCell('U').alignment = { horizontal: 'right' , vertical: 'middle' } ;

            //--------------------------------------------

            const headerRow = worksheet.getRow(4);
            const headerRow2 = worksheet.getRow(5);
            const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
            const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } } , right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, bottom: {style: 'thin', fgColor: { argb: 'bfbfbf' }}, top: {style: 'thin', fgColor: { argb: 'bfbfbf' }} }
            let headerRowLength = headerRow._cells.length            

            for(let i = 1; i <= headerRowLength; i++){
                headerRow.getCell(i).fill = headerStyle
                headerRow.getCell(i).border = headerBorderStyle
                headerRow.getCell(i).alignment = { horizontal: 'center' }

                headerRow2.getCell(i).fill = headerStyle
                headerRow2.getCell(i).border = headerBorderStyle
                headerRow2.getCell(i).alignment = { horizontal: 'center' }
            }


            for(let j = 6; j <= worksheet._rows.length; j++){
                for(let a = 1; a <= worksheet.getRow(j)._cells.length; a++){
                    worksheet.getRow(j).getCell(a).border = headerBorderStyle
                }
            }
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ResidueSteelList.xlsx');
            });
        });
        this.gridMainInstance.cancel = true;
        },               
    },
    mounted() {
        var date = new Date();
       
        this.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
        this.endDate   = new Date(date.getFullYear(), date.getMonth(), 1);

        this.getShipNoList()
        this.getUseShipNoList()
        //this.gridMainInstance.option('defaultPaging', false)
    }
}
</script>

<style scoped>

</style>